import React, {useEffect, useState, useCallback} from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Box,  Select } from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import CenterService from "../services/manage/CenterService";
/**
 * 처방전 선택
 * @param {*} props 
 */
export default function CenterSelect(props) {
    const classes = useStyles()
    const [ centers, setCenters ] = useState(null)
    
    const fetch = useCallback(async () => {
        setCenters(await CenterService.getCenter(''))
    },[props.profileID])
    
    useEffect(() => {
        fetch().then()
        
        return (() => {
            setCenters(null)
        })
    }, [fetch]);
    
    useEffect(() => {
        fetch().then()
    },[fetch, props.reload])
    
    if(!centers) return <></>
    
    return (
        <Box className={classes.root}>
            <Select
                value={props.defaultValue}
                className={classes.underline}
                onChange={(event)=>{
                    if(props.onChange){
                        props.onChange(event.target.value)
                        return
                    }
                    
                }}>
              <MenuItem
                value={-1}
                className={clsx( {
                  [classes.active]: '' === Number(props.defaultValue)
                })}
              >
                <span className={clsx('title',{
                  'text-white': -1 ===Number(props.defaultValue)
                })} >전체</span>
              </MenuItem>
              
                {centers.map((center)=>{
                    return (
                        <MenuItem
                            key={center.id}
                            value={center.id}
                            className={clsx( {
                                [classes.active]: center.id === Number(props.defaultValue)
                            })}
                        >
                            <span className={clsx('title',{
                              'text-white': center.id === Number(props.defaultValue)
                            })} >{center.name}</span>
                        </MenuItem>
                    )
                })}
            </Select>
        </Box>
    )
}

const useStyles = makeStyles(() => ({
    root: {
        border: '1px solid #BEBEBE',
        padding:17,
        
        '& .MuiInput-underline::before': {
            
        },
        '& .MuiSelect-selectMenu': {
            paddingLeft: 10,
            paddingTop: 0,
            paddingBottom: 0
        },
        '& .title': {
            fontWeight: 'bold'
        },
        '& .sub': {
            fontSize:14, 
            paddingLeft: 10,
        },
        '& .MuiSelect-icon': {
            color: '#0055BF',
        },
    },
    underline: {
        "&&&:before": {
            borderBottom: "none"
        },
        "&&:after": {
            borderBottom: "none"
        },
    },
    active: {
        backgroundColor: '#0055BF',
        color: 'white',
        '& .title': {
            color: 'white'
        }
    },
    gray: {
      color: '#666'
    }
 
}));
